// extracted by mini-css-extract-plugin
module.exports = {"title":"reportHeader_title__1fVTF"};